import { render, staticRenderFns } from "./SkillsList.vue?vue&type=template&id=03ababe3&"
import script from "./SkillsList.vue?vue&type=script&lang=js&"
export * from "./SkillsList.vue?vue&type=script&lang=js&"
import style0 from "./SkillsList.vue?vue&type=style&index=0&id=03ababe3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports